import { render, staticRenderFns } from "./CapitalesLocal.vue?vue&type=template&id=4a51c3a4&scoped=true&"
import script from "./CapitalesLocal.vue?vue&type=script&lang=js&"
export * from "./CapitalesLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a51c3a4",
  null
  
)

export default component.exports